import pull from 'lodash/pull'
import SockJS from 'sockjs-client'
import type { SocketData as Data, ListenerFunc } from '@/lib/socket/types'

let sock: WebSocket | null = null

const buffer: Array<[string, Data | undefined]> = []
const listenerMap = new Map<string, ListenerFunc[]>()

function on(type: string, listener: ListenerFunc) {
  if (!listenerMap.has(type)) {
    listenerMap.set(type, [])
  }

  listenerMap.get(type)?.push(listener)

  return () => pull(listenerMap.get(type) ?? [], listener)
}

function pub(type: string, data?: Data) {
  if (!listenerMap.has(type)) {
    return
  }

  listenerMap.get(type)?.forEach((fn) => fn(data))
}

function emit(type: string, data?: Data) {
  if (sock?.readyState !== 1) {
    buffer.push([type, data])
  } else {
    sock.send(JSON.stringify({ type, data }))
  }
}

function close() {
  if (sock?.readyState === 1) {
    sock.close()
  }
}

let idSetT: ReturnType<typeof setTimeout>

function startConnecting() {
  function connect() {
    const isReconnecting = Boolean(sock)
    const uri = import.meta.env.VITE_WS_SERVER_URI ?? '/ws'
    const useSockJs = import.meta.env.VITE_USE_SOCK_JS === 'true'
    if (useSockJs) {
      sock = new SockJS(uri, null, { transports: ['websocket'] })
    } else {
      sock = new WebSocket(uri)
    }
    sock.onopen = function () {
      while (buffer.length > 0) {
        const eventToEmit = buffer.shift()
        if (eventToEmit) {
          emit(...eventToEmit)
        }
      }
      if (isReconnecting) {
        pub('reconnect')
      }
    }
    sock.onmessage = function (e) {
      const { type, data } = JSON.parse(e.data)
      pub(type, data)
    }
    sock.onclose = function () {
      clearTimeout(idSetT)
      idSetT = setTimeout(() => check(), 1000)
    }
  }

  function check() {
    if (!sock || sock.readyState === 3) {
      connect()
    }
  }

  connect()

  setInterval(check, 5000)
}

startConnecting()

export default {
  on,
  emit,
  close,
}
